import { render, staticRenderFns } from "./InstitutionList.vue?vue&type=template&id=77fe9faa&scoped=true&lang=pug"
import script from "./InstitutionList.vue?vue&type=script&lang=js"
export * from "./InstitutionList.vue?vue&type=script&lang=js"
import style0 from "./InstitutionList.vue?vue&type=style&index=0&id=77fe9faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe9faa",
  null
  
)

export default component.exports